import { useCallback } from 'react';
import { useAuthenticatedFetchWithWorkspace } from '../Keycloak/useAuthenticatedFetchWithWorkspace';
import { SavedQueryCondition } from '../../types/QueryBuilder';
import { useRequestState } from './useRequestState';

export interface QueryDetails {
    QUERY_ID: string;
    USER_ID: string;
    QUERY_TYPE: string;
    DESCRIPTION: string;
    SOURCE: string;
    UPDATE_DATE: string;
    QUERY_NAME: string;
    GROUP_QUERY_ID?: string | null;
    conditions?: SavedQueryCondition[] | null;
    // Ciblée par une campagne : ses critères ne se modifient plus que dans une copie
    USED_IN_CAMPAIGN?: boolean;
}

export const useQueryDetails = () => {
    const { authFetch, isReady } = useAuthenticatedFetchWithWorkspace();
    const { loading, error, run } = useRequestState();

    const fetchQueryDetails = useCallback(async (queryId: string): Promise<QueryDetails | null> => {
        if (!isReady || !queryId) return null;
        return run<QueryDetails>(
            () => authFetch(`/getQueryById?queryId=${queryId}`, { method: 'GET' }),
            'Erreur de récupération des détails'
        );
    }, [authFetch, isReady, run]);

    return { fetchQueryDetails, loading, error };
};
